import React from 'react';
export function Footer() {
  return <footer className="bg-gray-800 text-white py-12" data-id="element-5">
      <div className="max-w-6xl mx-auto px-4" data-id="element-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-7">
          <div data-id="element-8">
            <h3 className="text-xl font-bold mb-4" data-id="element-9">HubSpot</h3>
            <ul className="space-y-2" data-id="element-10">
              <li data-id="element-11">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-12">
                  About Us
                </a>
              </li>
              <li data-id="element-13">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-14">
                  Careers
                </a>
              </li>
              <li data-id="element-15">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-16">
                  Contact Us
                </a>
              </li>
              <li data-id="element-17">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-18">
                  Press
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-19">
            <h3 className="text-xl font-bold mb-4" data-id="element-20">Products</h3>
            <ul className="space-y-2" data-id="element-21">
              <li data-id="element-22">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-23">
                  Marketing Hub
                </a>
              </li>
              <li data-id="element-24">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-25">
                  Sales Hub
                </a>
              </li>
              <li data-id="element-26">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-27">
                  Service Hub
                </a>
              </li>
              <li data-id="element-28">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-29">
                  CMS Hub
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-30">
            <h3 className="text-xl font-bold mb-4" data-id="element-31">Resources</h3>
            <ul className="space-y-2" data-id="element-32">
              <li data-id="element-33">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-34">
                  Blog
                </a>
              </li>
              <li data-id="element-35">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-36">
                  Guides
                </a>
              </li>
              <li data-id="element-37">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-38">
                  Webinars
                </a>
              </li>
              <li data-id="element-39">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-40">
                  Tools
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-41">
            <h3 className="text-xl font-bold mb-4" data-id="element-42">Connect</h3>
            <ul className="space-y-2" data-id="element-43">
              <li data-id="element-44">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-45">
                  Facebook
                </a>
              </li>
              <li data-id="element-46">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-47">
                  Twitter
                </a>
              </li>
              <li data-id="element-48">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-49">
                  Instagram
                </a>
              </li>
              <li data-id="element-50">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-51">
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-700 text-center text-gray-400" data-id="element-52">
          <p data-id="element-53">© 2023 HubSpot, Inc. All Rights Reserved.</p>
        </div>
      </div>
    </footer>;
}